import { GlobalDesignGroupAction } from '../types';
import { groupByGroupDefinitions } from '../common/grouping/defaultGroupingStrategy';

export const strokeGrouping: GlobalDesignGroupAction['grouping'] = {
  getGroupingStrategy: (editorPointers, getHost, componentsAPI) => {
    return () => {
      return groupByGroupDefinitions(
        editorPointers,
        'strokeStyles',
        getHost,
        componentsAPI,
      );
    };
  },
};
